import { Box } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import CustomButton from "../../../../components/CustomButton";
import FilterSVG from "../../../../../media/images/icons/filter-icon";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../redux/features/snackbarSlice";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/useRedux";
import { useFormik } from "formik";
import FiltersBottomSheet from "./FiltersBottomSheet";
import FilterItem from "./FilterItem";
import EmptyListBox from "../../../../components/EmptyListBox";
import LoadingBox from "../../../../components/LoadingBox";
import { IOrder } from "../../../../../types/driver";
import { useInView } from "react-intersection-observer";
import OrdersList from "./OrdersList";

export default function FreightsList() {
  const [activeFilters, setActiveFilters] = useState<
    {
      filter: any | null;
      key: string;
    }[]
  >([]);

  const [orders, setOrders] = useState<IOrder[]>([]);

  const { vehicleInfo } = useAppSelector((state) => state.user);

  const [pageN, setPageN] = useState(1);

  const [nextPageLoading, setNextPageLoading] = useState(true);

  const [goodsTypeInputValue, setGoodsTypeInputValue] = useState("");
  const [loaderGroupInputValue, setLoaderGroupInputValue] = useState("");
  const [packageTypeInputValue, setPackageTypeInputValue] = useState("");
  const [destinationInputValue, setDestinationInputValue] = useState("");
  const [originInputValue, setOriginInputValue] = useState("");

  const [goodsTypes, setGoodsTypes] = useState([]);
  const [loaderGroups, setLoaderGroups] = useState([]);
  const [packageTypes, setPackageTypes] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [origins, setOrigins] = useState([]);

  const [tempGoodType, setTempGoodType] = useState(null);
  const [tempLoaderGroup, setTempLoaderGroup] = useState(null);
  const [tempPackageType, setTempPackageType] = useState(null);
  const [tempDestination, setTempDestination] = useState(null);
  const [tempOrigin, setTempOrigin] = useState(null);

  const [filtersState, setFilterState] = useState(false);
  const getCargosFormik = useFormik({
    initialValues: {
      goodType: null,
      loaderGroup: null,
      packageType: null,
      destination: null,
      origin: null,
    },
    onSubmit: () => {
      getCargosFormik.setFieldValue("goodType", tempGoodType);
      getCargosFormik.setFieldValue("loaderGroup", tempLoaderGroup);
      getCargosFormik.setFieldValue("packageType", tempPackageType);
      getCargosFormik.setFieldValue("origin", tempOrigin);
      getCargosFormik.setFieldValue("destination", tempDestination);

      setActiveFilters([
        {
          filter: tempGoodType,
          key: "goodType",
        },
        {
          filter: tempLoaderGroup,
          key: "loaderGroup",
        },
        {
          filter: tempPackageType,
          key: "packageType",
        },
        {
          filter: tempOrigin,
          key: "origin",
        },
        {
          filter: tempDestination,
          key: "destination",
        },
      ]);
      setFilterState(false);
    },
  });

  const { trigger: getSalonOrders, isMutating: isGetOrdersMutating } =
    useSWRMutation(
      [`/Order/SearchSalonOrders`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: async (data) => {
          setOrders(data);
          setNextPageLoading(false);
        },
      }
    );

  const {
    trigger: getSalonOrdersNextPage,
    isMutating: isGetOrdersMutatingNextPage,
  } = useSWRMutation(
    [`/Order/SearchSalonOrders`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        setOrders([...orders, ...data]);

        setNextPageLoading(false);
      },
    }
  );

  const {
    trigger: getGoodsTypesTrigger,
    // isMutating: isGetLoaderTypesTriggerMutating,
  } = useSWRMutation(
    [`/Goods/SearchByName`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setGoodsTypes(() =>
          data.map((item: any) => ({
            label: item.name,
            value: item.code,
          }))
        );
      },
    }
  );
  const {
    trigger: getLoaderGroupTrigger,
    isMutating: isgetLoaderGroupTriggerTriggerMutating,
  } = useSWRMutation(
    [`/LoaderType/TakeLoaderGroup`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setLoaderGroups(data);
      },
    }
  );

  const {
    trigger: getPackgaeTypesTrigger,
    // isMutating: isgetPackageTypesTriggerTriggerMutating,
  } = useSWRMutation(
    [`/PackageType/SearchByName`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setPackageTypes(() =>
          data.map((item: any) => ({
            label: item.name,
            value: item.code,
          }))
        );
      },
    }
  );
  const {
    trigger: getCityTrigger,
    // isMutating: isGetCityTriggerMutating
  } = useSWRMutation(
    [`/City/SearchByName`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setOrigins((prev) =>
          data.map((item: any) => ({
            label: item.name,
            value: item.code,
          }))
        );
      },
    }
  );

  const {
    trigger: getDestinationsTrigger,
    // isMutating: isGetDestinationsTriggerMutating,
  } = useSWRMutation(
    [`/City/SearchByName`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setDestinations((prev) =>
          data.map((item: any) => ({
            label: item.name,
            value: item.code,
          }))
        );
      },
    }
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      goodsTypeInputValue &&
        getGoodsTypesTrigger({
          name: goodsTypeInputValue,
        });
    }, 1000);
    return () => clearTimeout(timer);
  }, [goodsTypeInputValue]);

  useEffect(() => {
    const timer = setTimeout(() => {
      loaderGroupInputValue &&
        getLoaderGroupTrigger({
          name: loaderGroupInputValue,
        });
    }, 1000);
    return () => clearTimeout(timer);
  }, [loaderGroupInputValue]);

  useEffect(() => {
    const timer = setTimeout(() => {
      packageTypeInputValue &&
        getPackgaeTypesTrigger({
          name: packageTypeInputValue,
        });
    }, 1000);
    return () => clearTimeout(timer);
  }, [packageTypeInputValue]);
  useEffect(() => {
    const timer = setTimeout(() => {
      originInputValue &&
        getCityTrigger({
          name: originInputValue,
        });
    }, 1000);
    return () => clearTimeout(timer);
  }, [originInputValue]);
  useEffect(() => {
    const timer = setTimeout(() => {
      destinationInputValue &&
        getDestinationsTrigger({
          name: destinationInputValue,
        });
    }, 1000);
    return () => clearTimeout(timer);
  }, [destinationInputValue]);

  const handleChangeAutoComplete = (selected: any, type?: string) => {
    switch (type) {
      case "goodType":
        setTempGoodType(selected);
        break;
      case "loaderGroup":
        setTempLoaderGroup(selected);
        break;

      case "packageType":
        setTempPackageType(selected);
        break;
      case "origin":
        setTempOrigin(selected);

        break;
      case "destination":
        setTempDestination(selected);

        break;

      default:
        break;
    }
  };

  const handleResetForm = () => {
    setTempGoodType(null);
    setTempLoaderGroup(null);
    setTempPackageType(null);
    setTempOrigin(null);
    setTempDestination(null);
  };

  const handleRemoveFilter = (key?: string) => {
    switch (key) {
      case "goodType":
        getCargosFormik.setFieldValue("goodType", null);

        setActiveFilters((prev) =>
          prev.filter((item) => item?.key !== "goodType")
        );
        break;
      case "loaderGroup":
        getCargosFormik.setFieldValue("loaderGroup", null);
        setActiveFilters((prev) =>
          prev.filter((item) => item?.key !== "loaderGroup")
        );

        break;
      case "packageType":
        getCargosFormik.setFieldValue("packageType", null);
        setActiveFilters((prev) =>
          prev.filter((item) => item?.key !== "packageType")
        );
        break;
      case "origin":
        getCargosFormik.setFieldValue("origin", null);
        setActiveFilters((prev) =>
          prev.filter((item) => item?.key !== "origin")
        );
        break;
      case "destination":
        getCargosFormik.setFieldValue("destination", null);
        setActiveFilters((prev) =>
          prev.filter((item) => item?.key !== "destination")
        );
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    const goodType = activeFilters.find((f) => f.key === "goodType")?.filter;
    const packageType = activeFilters.find((f) => f.key === "packageType")?.filter;
    const loaderGroup = activeFilters.find((f) => f.key === "loaderGroup")?.filter;
    const origin = activeFilters.find((f) => f.key === "origin")?.filter;
    const destination = activeFilters.find((f) => f.key === "destination")?.filter;

    const payload = {
      destinationCode: destination ? Number(destination["value"]) : 0,
      sourceCode: origin ? Number(origin["value"]) : 0,
      fareFrom: 0,
      fareTo: 0,
      goodsCode: goodType ? goodType["value"] : 0,
      loaderGroup: loaderGroup ? loaderGroup["value"] : null,
      loaderTypeCode: 0,
      orderSalonType: 0,
      packageTypeCode: packageType ? packageType["value"] : 0,
      pageNr: 1,
      salonCode: 0,
      weightFrom: 0,
      weightTo: 0,
    };


    setPageN(() => 1);
    setNextPageLoading(true);
    getSalonOrders(payload);
  }, [activeFilters, vehicleInfo]);

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  useEffect(() => {
    if (inView) {
      const goodType = activeFilters.find((f) => f.key === "goodType")?.filter;
      const packageType = activeFilters.find((f) => f.key === "packageType")?.filter;
      const loaderGroup = activeFilters.find((f) => f.key === "loaderGroup")?.filter;
      const origin = activeFilters.find((f) => f.key === "origin")?.filter;
      const destination = activeFilters.find((f) => f.key === "destination")?.filter;

      setPageN((prev) => prev + 1);
      setNextPageLoading(true);
      const newPageN = pageN + 1;
      getSalonOrdersNextPage({
        destinationCode: destination ? Number(destination["value"]) : 0,
        sourceCode: origin ? Number(origin["value"]) : 0,
        fareFrom: 0,
        fareTo: 0,
        goodsCode: goodType ? goodType["value"] : 0,
        loaderGroup: loaderGroup ? loaderGroup["value"] : null,
        loaderTypeCode: 0,
        orderSalonType: 0,
        packageTypeCode: packageType ? packageType["value"] : 0,
        pageNr: newPageN,
        salonCode: 0,
        weightFrom: 0,
        weightTo: 0,
      });
    }
  }, [inView]);

  return (
    <>
      <FiltersBottomSheet
        open={filtersState}
        onDismiss={() => setFilterState(false)}
        onOk={() => getCargosFormik.handleSubmit()}
        handleChangeAutoComplete={handleChangeAutoComplete}
        handleResetForm={handleResetForm}
        goodsType={{
          inputValue: goodsTypeInputValue,
          setValue: setGoodsTypeInputValue,
          value: tempGoodType,
          goodsTypes: goodsTypes,
        }}
        loaderGroup={{
          inputValue: loaderGroupInputValue,
          setValue: setLoaderGroupInputValue,
          value: tempLoaderGroup,
          loaderGroups: loaderGroups,
        }}
        packageType={{
          inputValue: packageTypeInputValue,
          setValue: setPackageTypeInputValue,
          value: tempPackageType,
          packageTypes: packageTypes,
        }}
        origin={{
          inputValue: originInputValue,
          setValue: setOriginInputValue,
          value: tempOrigin,
          origins: origins,
        }}
        destination={{
          inputValue: destinationInputValue,
          setValue: setDestinationInputValue,
          value: tempDestination,
          destinations: destinations,
        }}
      />

      <Box
        sx={{
          width: "100%",
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            padding: "4px 8px 8px 0px",
          }}
        >
          <CustomButton
            onClick={() => {
              setTempGoodType(activeFilters.find((f) => f.key === "goodType")?.filter ?? null);
              setTempLoaderGroup(activeFilters.find((f) => f.key === "loaderGroup")?.filter ?? null);
              setTempPackageType(activeFilters.find((f) => f.key === "packageType")?.filter ?? null);
              setTempOrigin(activeFilters.find((f) => f.key === "origin")?.filter ?? null);
              setTempDestination(activeFilters.find((f) => f.key === "destination")?.filter ?? null);
              setFilterState(true);
            }}
            title={
              getCargosFormik.values.goodType ||
              getCargosFormik.values.loaderGroup ||
              getCargosFormik.values.origin ||
              getCargosFormik.values.destination ||
              getCargosFormik.values.packageType
                ? "ویرایش فیلتر"
                : "تنظیم فیلتر"
            }
            bgColor="secondary.main"
            fSize="14px"
            px="6px"
            py="8px"
            borderRadius="6px"
            icon1={<FilterSVG size={14} color={"#fff"} />}
          />
          <Box
            sx={{
              flex: "1",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              overflowX: "auto",
              padding: "4px 0px 4px 4px",
              "&::-webkit-scrollbar": {
                height: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1", // Scrollbar track color
              },
            }}
          >
            {activeFilters?.map(
              (item) =>
                !!item.filter && (
                  <FilterItem
                    item={item}
                    handleRemoveFilter={handleRemoveFilter}
                  />
                )
            )}
          </Box>
        </Box>

        {/* <Box
            sx={{
              flex: "1",
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              gap: "6px",
            }}
          >
            <Typography
              noWrap
              sx={{
                color: "primary.main",
                fontSize: "14px",
              }}
            >
              مرتب بر اساس:
            </Typography>
            <CustomSelectOption
              type="companyActivity"
              setValue={setValue}
              width="50%"
              height="40px"
              value={"1"}
              // error={companyActivity.error}
              // errorMessage={companyActivity.errorMessage}
              options={[
                {
                  label: "همه",
                  value: 1,
                },
                {
                  label: "بیشترین کرایه",
                  value: 1,
                },
                {
                  label: "بیشترین کرایه",
                  value: 2,
                },
              ]}
            />
          </Box> */}
      </Box>

      {isGetOrdersMutating ? (
        <LoadingBox />
      ) : orders?.length ? (
        <OrdersList
          nextPageLoading={nextPageLoading}
          orders={orders}
          pagN={pageN}
          ref={ref}
        />
      ) : (
        <EmptyListBox description="در حال حاضر محموله‌ای برای دریافت وجود ندارد!" />
      )}
    </>
  );
}
